module.exports = __webpack_public_path__ + "_/img/MapMarker4.ed2d10af.svg";